/* Keep the hero and sticky-bar CTAs on the page.
   Added 2026-09-26.

   THE PROBLEM. The hero button and the sticky bar button both pointed at
   /products/make-more-music-t-shirt, so the first thing a visitor did after
   landing on the ad page was leave it. Everything the page was built to do -
   the story, the reviews, the tip block, and the hoodie sitting directly under
   the tee - was skipped by the one click the page most wants people to make.
   Scrolling to the buy box keeps all of it in front of them, and the hoodie
   gets seen on the way past whether or not they were looking for it.

   WHY THIS IS JAVASCRIPT AND NOT JUST A CHANGED LINK. It could have been done
   by editing the two button links in templates/page.make-more-music.json to
   read '#buy-make-more-music-t-shirt'. That file is 22KB of generated JSON that
   the theme editor rewrites whenever anyone touches the page, so a hand edit
   there is both risky to make and liable to be overwritten. Doing it here means
   the behaviour survives page edits and applies automatically to any buy box
   added later - no second code change, no forgotten step.

   THE SCROLLER IS NOT THE WINDOW. Horizon sets overflow:hidden on both html and
   body and scrolls div.page-wrapper instead. window.scrollY is always 0 on this
   theme and window.scrollTo does nothing, so anything that needs the scroll
   position has to find the scrolling ancestor first. scrollerFor does that.
   The landing position is set by scroll-margin-top on the buy box, which
   sections/rr-van-buybox.liquid exposes as a setting so the stop can be tuned
   when the sticky header changes height.

   THE SAFETY NET AT THE BOTTOM OF jump(). scrollIntoView with behavior:'smooth'
   is an animation, and animations need the tab to be producing frames. In a
   background tab it is a silent no-op - the hash updates, no error is thrown,
   and the page does not move. That is a testing artifact rather than something
   a real visitor hits, but it is cheap to be certain: if nothing has moved a
   few hundred milliseconds after the click, the scroll is forced instantly.
   Verified 2026-09-26 that the forced path lands the buy box correctly; the
   animated path could not be observed under automation because the tab reported
   visibilityState 'hidden' and requestAnimationFrame produced zero frames.

   SCOPE IS DELIBERATELY NARROW. Only links inside .rrvf-hero and .rr-sticky are
   touched. A blanket rule over every product link on the page would also catch
   links written into the story copy, where 'go to the product page' is what the
   sentence actually means.

   IT DEGRADES TO THE OLD BEHAVIOUR. If this file fails to load, the buttons are
   still ordinary links to the product page. Nothing breaks.

   MODIFIED CLICKS ARE LEFT ALONE. Cmd/Ctrl/Shift click and middle click keep
   their normal meaning, so 'open in a new tab' still opens the product page. */
(function () {
  'use strict';

  if (window.__rrBuyboxScrollBound) return;
  window.__rrBuyboxScrollBound = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function scrollerFor(el) {
    var node = el.parentElement;

    while (node && node !== document.body && node !== document.documentElement) {
      var style = window.getComputedStyle(node);
      if (
        /(auto|scroll|overlay)/.test(style.overflowY) &&
        node.scrollHeight > node.clientHeight + 4
      ) {
        return node;
      }
      node = node.parentElement;
    }

    return document.scrollingElement || document.documentElement;
  }

  function targetOffset(el, container) {
    var isRoot =
      container === document.scrollingElement || container === document.documentElement;
    var containerTop = isRoot ? 0 : container.getBoundingClientRect().top;
    var marginTop = parseFloat(window.getComputedStyle(el).scrollMarginTop);
    if (isNaN(marginTop)) marginTop = 0;

    var raw = container.scrollTop + (el.getBoundingClientRect().top - containerTop) - marginTop;
    var max = Math.max(0, container.scrollHeight - container.clientHeight);

    return Math.max(0, Math.min(raw, max));
  }

  function land(target) {
    // Carry the keyboard caret across, otherwise a screen reader or the tab key
    // carries on from the button the visitor just left.
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try {
      target.focus({ preventScroll: true });
    } catch (e) {
      /* older browsers ignore the options object; the scroll already happened */
    }
  }

  function forceTo(container, to) {
    var previous = container.style.scrollBehavior;
    container.style.scrollBehavior = 'auto';
    container.scrollTop = to;
    container.style.scrollBehavior = previous;
  }

  function jump(target) {
    var container = scrollerFor(target);
    var to = targetOffset(target, container);
    forceTo(container, to);
    land(target);
  }

  ready(function () {
    var boxes = document.querySelectorAll('[data-rr-buy-handle]');
    if (!boxes.length) return;

    var byHandle = {};
    Array.prototype.forEach.call(boxes, function (box) {
      var handle = box.getAttribute('data-rr-buy-handle');
      if (handle && !byHandle[handle]) byHandle[handle] = box;
    });

    var links = document.querySelectorAll('.rrvf-hero a[href], .rr-sticky a[href]');

    Array.prototype.forEach.call(links, function (link) {
      var url;
      try { url = new URL(link.href, window.location.href); } catch (e) { return; }
      if (url.origin !== window.location.origin) return;
      var target = null;
      if (url.pathname === window.location.pathname && url.hash.length > 1) {
        var id;
        try { id = decodeURIComponent(url.hash.slice(1)); } catch (e) { return; }
        var anchor = document.getElementById(id);
        if (anchor && anchor.hasAttribute('data-rr-buy-handle')) target = anchor;
      } else {
        var match = url.pathname.match(/\/products\/([^/?#]+)/);
        if (!match) return;
        var handle;
        try { handle = decodeURIComponent(match[1]); } catch (e) { handle = match[1]; }
        target = byHandle[handle];
      }
      if (!target) return;

      // Becomes a real in-page anchor, so hovering shows where it goes.
      if (target.id) link.setAttribute('href', '#' + target.id);
      link.removeAttribute('target');

      link.addEventListener('click', function (event) {
        if (
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        event.preventDefault();
        jump(target);

        if (target.id && window.history && typeof history.replaceState === 'function') {
          history.replaceState(null, '', '#' + target.id);
        }
      });
    });
  });
})();
